import React, { useState } from "react";
import Sidebar from "./Sidebar";
import EmployeeData from "./EmployeeData";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudArrowDown } from "@fortawesome/free-solid-svg-icons";

const Dashboard = () => {
  const today = new Date();
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // ✅ Default to current month & year
  const [month, setMonth] = useState(monthNames[today.getMonth()]);
  const [year, setYear] = useState(today.getFullYear().toString());

  const [selectedEmpId, setSelectedEmpId] = useState("");
  const [selectedEmpName, setSelectedEmpName] = useState("");
  const [loading, setLoading] = useState(false);

  const handleEmployeeClick = (empId, empName) => {
    setSelectedEmpId(empId);
    setSelectedEmpName(empName);
  };

  //------------------------------------------------------//

  const monthIndexMap = {
    January: 0,
    February: 1,
    March: 2,
    April: 3,
    May: 4,
    June: 5,
    July: 6,
    August: 7,
    September: 8,
    October: 9,
    November: 10,
    December: 11,
  };

  const getMonthDateRange = (monthName, year) => {
    const monthIndex = monthIndexMap[monthName];
    const fromDate = new Date(year, monthIndex, 2);
    const toDate = new Date(year, monthIndex + 1, 1);

    const format = (d) => d.toISOString().split("T")[0];

    return {
      fromDate: format(fromDate),
      toDate: format(toDate),
    };
  };

  const { fromDate, toDate } = getMonthDateRange(month, year);

  //------------------------------------------------------//
  const downloadExcel = () => {
    const from = fromDate;
    const to = toDate;
    const downloadUrl = `https://principleacs.net/attendance_excel.php?from=${from}&to=${to}`;

    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute("download", `AllEmployees_${month}_${year}.xlsx`);
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div>
      <div style={{ padding: "2px" }}>
        <label>Month: </label>
        <select onChange={(e) => setMonth(e.target.value)} value={month}>
          {monthNames.map((m, i) => (
            <option key={i} value={m}>
              {m}
            </option>
          ))}
        </select>

        <label style={{ marginLeft: "10px" }}>Year: </label>
        <input
          type="number"
          value={year}
          onChange={(e) => setYear(e.target.value)}
        />

        <button
          onClick={downloadExcel}
          disabled={loading}
          className="btn btn-primary m-2"
        >
          <FontAwesomeIcon icon={faCloudArrowDown} />{" "}
          {loading ? "Downloading..." : "Download Excel"}
        </button>
      </div>

      <div style={{ display: "flex" }}>
        <Sidebar onEmployeeClick={handleEmployeeClick} />
        <EmployeeData
          empId={selectedEmpId}
          empName={selectedEmpName}
          month={month}
          year={year}
        />
      </div>
    </div>
  );
};

export default Dashboard;

//--------------------------perfect---------------------------//

// import React, { useState } from "react";
// import Sidebar from "./Sidebar";
// import EmployeeData from "./EmployeeData";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faCloudArrowDown } from "@fortawesome/free-solid-svg-icons";

// const Dashboard = () => {
//   const [selectedEmpId, setSelectedEmpId] = useState("");
//   const [selectedEmpName, setSelectedEmpName] = useState("");
//   const today = new Date();
//   const [month, setMonth] = useState(monthNames[today.getMonth()]);
//   const [year, setYear] = useState(today.getFullYear().toString());
//   // const [month, setMonth] = useState("June");
//   // const [year, setYear] = useState("2025");
//   const [loading, setLoading] = useState(false);

//   const handleEmployeeClick = (empId, empName) => {
//     setSelectedEmpId(empId);
//     setSelectedEmpName(empName);
//   };

//   //------------------------------------------------------//

//   // const monthNames = {
//   //   January: 0,
//   //   February: 1,
//   //   March: 2,
//   //   April: 3,
//   //   May: 4,
//   //   June: 5,
//   //   July: 6,
//   //   August: 7,
//   //   September: 8,
//   //   October: 9,
//   //   November: 10,
//   //   December: 11,
//   // };

//   const monthNames = [
//     "January",
//     "February",
//     "March",
//     "April",
//     "May",
//     "June",
//     "July",
//     "August",
//     "September",
//     "October",
//     "November",
//     "December",
//   ];

//   const getMonthDateRange = (monthName, year) => {
//     const monthIndex = monthNames[monthName];
//     const fromDate = new Date(year, monthIndex, 2);
//     const toDate = new Date(year, monthIndex + 1, 1); // last day of month

//     const format = (d) => d.toISOString().split("T")[0];

//     return {
//       fromDate: format(fromDate),
//       toDate: format(toDate),
//     };
//   };
//   const { fromDate, toDate } = getMonthDateRange(month, year);
//   //------------------------------------------------------//
//   const downloadExcel = () => {
//     const from = fromDate;
//     const to = toDate;
//     const downloadUrl = `https://principleacs.net/attendance_excel.php?from=${from}&to=${to}`;

//     // Trigger browser download via anchor
//     const link = document.createElement("a");
//     link.href = downloadUrl;
//     link.setAttribute("download", `AllEmployees_${month}_${year}.xlsx`);
//     link.target = "_blank"; // Optional: opens in new tab
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   return (
//     <div>
//       <div style={{ padding: "2px" }}>
//         <label>Month: </label>
//         <select onChange={(e) => setMonth(e.target.value)} value={month}>
//           {[
//             "January",
//             "February",
//             "March",
//             "April",
//             "May",
//             "June",
//             "July",
//             "August",
//             "September",
//             "October",
//             "November",
//             "December",
//           ].map((m, i) => (
//             <option key={i} value={m}>
//               {m}
//             </option>
//           ))}
//         </select>
//         <label style={{ marginLeft: "10px" }}>Year: </label>
//         <input
//           type="number"
//           value={year}
//           onChange={(e) => setYear(e.target.value)}
//         />

//         <button
//           onClick={downloadExcel}
//           disabled={loading}
//           className="btn btn-primary m-2"
//         >
//           <FontAwesomeIcon icon={faCloudArrowDown} />{" "}
//           {loading ? "Downloading..." : "Download Excel"}
//         </button>

//         {/* <div className="download-excel-view" style={{ paddingBottom: "10px" }}>
//           <button
//             onClick={downloadExcel}
//             disabled={loading}
//             className="btn btn-primary"
//           >
//             <FontAwesomeIcon icon={faCloudArrowDown} />{" "}
//             {loading ? "Downloading..." : "Download Excel"}
//           </button>
//         </div> */}
//       </div>

//       <div style={{ display: "flex" }}>
//         <Sidebar onEmployeeClick={handleEmployeeClick} />
//         <EmployeeData
//           empId={selectedEmpId}
//           empName={selectedEmpName}
//           month={month}
//           year={year}
//         />
//       </div>
//     </div>
//   );
// };

// export default Dashboard;

//------------------------------------------------------------------------//
// import React, { useState } from "react";
// import Sidebar from "./Sidebar";
// import EmployeeData from "./EmployeeData";

// const Dashboard = () => {
//   const [selectedEmpId, setSelectedEmpId] = useState("");

//   const handleEmployeeClick = (empId) => {
//     setSelectedEmpId(empId);
//   };

//   return (
//     <div style={{ display: "flex" }}>
//       <Sidebar onEmployeeClick={handleEmployeeClick} />
//       <EmployeeData empId={selectedEmpId} />
//     </div>
//   );
// };

// export default Dashboard;

// import React, { useState } from "react";
// import Sidebar from "./Sidebar";
// import EmployeeData from "./EmployeeData";

// const Dashboard = () => {
//   const [selectedEmpId, setSelectedEmpId] = useState("");

//   const handleEmployeeClick = (empId) => {
//     setSelectedEmpId(empId);
//   };

//   return (
//     <div style={{ display: "flex" }}>
//       <Sidebar onEmployeeClick={handleEmployeeClick} />
//       <EmployeeData empId={selectedEmpId} />
//     </div>
//   );
// };

// export default Dashboard;
